const ISO_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/

export const isStrictIsoDate = (value: string): boolean => {
    const match = ISO_DATE_PATTERN.exec(value.trim())
    if (!match) return false
    const [, year, month, day] = match
    const parsed = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)))
    return parsed.getUTCFullYear() === Number(year) &&
        parsed.getUTCMonth() === Number(month) - 1 &&
        parsed.getUTCDate() === Number(day)
}

export const isValidDateTime = (value: string): boolean =>
    value.trim() !== '' && Number.isFinite(Date.parse(value))

export const isPastOrTodayIsoDate = (value: string): boolean => {
    if (!isStrictIsoDate(value)) return false
    const today = new Date()
    const todayIso = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`
    return value <= todayIso
}

export const isCommaSeparatedPositiveIntegerList = (value: string): boolean => {
    const parts = value.split(',').map(part => part.trim()).filter(Boolean)
    return parts.length > 0 && parts.every(part => /^[1-9]\d*$/.test(part))
}

export const isValidOptionalPhone = (value?: string | null): boolean => {
    const normalized = value?.trim() ?? ''
    return normalized === '' || (/^(?=.*\d)[+()0-9\s-]*$/u.test(normalized) && normalized.length <= 30)
}
